// export function

import Axios from "axios"
import { call, put, takeLatest } from "redux-saga/effects"
import { LOCAL_COMPANY_ID, LOCAL_TOKEN } from "../../../utils/storage"
import {
  getTwoFactorAuthActiveSucess,
  putTwoFactorAuthActiveSucess,
} from "./actions"
import {
  GET_TWO_FACTOR_AUTH_WATCHER,
  PUT_TWO_FACTOR_AUTH_WATCHER,
} from "./constants"

export function getTwoFactorAuthActiveApi() {
  return Axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}companies/${LOCAL_COMPANY_ID()}/configuration`,
  })
}

export function* getTwoFactorAuthActiveSaga(params) {
  try {
    const { data, status } = yield call(getTwoFactorAuthActiveApi)
    if (status == 200) {
      yield put(getTwoFactorAuthActiveSucess(data))
    }
  } catch (e) {
    // yield put(getTwoFactorAuthActiveFailed())
    console.log(e)
  }
}

export function putTwoFactorAuthActiveApi(payload) {
  return Axios.request({
    method: "PUT",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/two_factor_auth`,
    data: payload,
  })
}

export function* putTwoFactorAuthActiveSaga(action) {
  try {
    const { payload } = action
    const { data, status } = yield call(putTwoFactorAuthActiveApi, payload)
    if (status == 201) {
      yield put(putTwoFactorAuthActiveSucess(data))
    }
  } catch (e) {
    // yield put(getTwoFactorAuthActiveFailed())
    console.error(e)
  }
}

export default function* customIndicatorsSaga() {
  // See example in containers/HomePage/saga.js
  yield takeLatest(GET_TWO_FACTOR_AUTH_WATCHER, getTwoFactorAuthActiveSaga)
  yield takeLatest(PUT_TWO_FACTOR_AUTH_WATCHER, putTwoFactorAuthActiveSaga)
}
